import {hpcAttrs} from '@github-ui/hpc'
export const ErrorMessage = ({errorMessage}: {errorMessage: string}) => (
  <div className="text-center tmp-p-3" {...hpcAttrs()}>
    {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
    <div className="msg">
      <p>{errorMessage}</p>
    </div>
  </div>
)
